import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/bizzsurfer.webp';
import screenshot_target from '../../../images/letterfunnel/marielschaab.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Mariel Schaab"
      firstname="Mariel"
      companyname="BizzSurfer"
      competition="Typology en AskBrian"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/marielschaab.js